import React, {Component} from "react";

// import '../../../css/SimFlexMAN/App.css';

class RightBlockSpacer extends Component {

	render() {
		return (
			<div className="Right-block-vertical-space"></div>
		);
	}
}

export default RightBlockSpacer;